import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import classnames from 'classnames';
import styles from './new_chip.module.scss';

type Props = {
  className?: string;
};

export const NewChip: FC<Props> = ({ className = '' }) => (
  <span className={classnames(styles.chip, className)}>
    <FormattedMessage id="NewChip/title" />
  </span>
);
